import {
  DocumentDetail,
  type DocumentDetail as DocumentDetailData,
} from "@/components/accounting/document-detail";
import { ApiError, api } from "@/lib/api";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

/** `/accounting/expenses/$id` — one received document. Read-only: what
 *  a supplier sent is their document, not ours to rewrite. */

export const Route = createFileRoute("/_app/accounting/expenses/$id")({
  loader: async ({ params }) => {
    try {
      return await api.get<DocumentDetailData>(
        `/api/accounting/documents/${params.id}?side=received`,
      );
    } catch (err) {
      if (err instanceof ApiError && err.status === 403) throw redirect({ to: "/my" });
      if (err instanceof ApiError && err.status === 404) throw notFound();
      throw err;
    }
  },
  component: Page,
});

function Page() {
  const document = Route.useLoaderData();
  const { t } = useTranslation();
  return (
    <DocumentDetail
      document={document}
      side="received"
      backTo="/accounting/expenses"
      backLabel={t("accExpenses.title")}
    />
  );
}
